export default __webpack_public_path__ + "src/shared/svg/providers/62ebd88f692b756cf33f7d660ac26e98.png";